'use client';

import { useTranslations } from 'next-intl';
import { HeaderAccountButton } from 'components/pcc-components';
import { useLogout } from 'hooks/use-logout';
import { CatPrimaryNavItem } from 'components/blocks-components';
import { useInAppSignOut } from '@cat-ecom/pcc-components/src/hooks/useInAppSignOut';
import { useLogin } from 'hooks/use-login';

type SignOutButtonProps = {
  logoutURL: string;
  isMobileMenu?: boolean;
};

export const SignOutButton = ({
  logoutURL,
  isMobileMenu = false
}: SignOutButtonProps) => {
  const t = useTranslations();
  const signOutLabel = t('HEADER_SIGN_OUT');
  const { logout } = useLogout();
  const { removeGuestCookies } = useLogin();
  const { getInAppCookie } = useInAppSignOut();

  const signOut = () => {
    removeGuestCookies();
    logout();
  };

  if (getInAppCookie()) return null;

  return isMobileMenu ? (
    <CatPrimaryNavItem
      data-testId="signOutNavItemMobile"
      text={signOutLabel}
      onClick={signOut}
      href={logoutURL}
      style={{
        borderBottom: '1px solid var(--cat-theme-color-border-strong-hover)'
      }}
    />
  ) : (
    <HeaderAccountButton
      label={signOutLabel}
      onClick={signOut}
      href={logoutURL}
    />
  );
};
